import React from "react";
import ErrorIcon from "../../assets/images/error.svg";
import { useTranslation } from "react-i18next";
import "../../assets/css/rating-template.css";

export default function Error404() {
  const { t } = useTranslation();

  /**
   * TODO: add more description 404 error message
   */
  return (
    <div className="error-container">
      <img src={ErrorIcon} alt="logo" className="oops-img" />
      <label className="recommendation">{t("oops")}</label>
    </div>
  );
}
